// Post-corrects the position of a VanillaContextMenu so it stays inside the
// viewport. The library's built-in `normalizePosition` clips to the scope
// element (a single table row in our usage), which leaves the menu hanging off
// the window edge for rows near the bottom or right. The library also calls
// stopPropagation() on the contextmenu event, so we hook via MutationObserver
// instead: when a `.context-menu` element is appended to <body>, we reposition
// it before the library's setTimeout flips it visible.

const VIEWPORT_MARGIN = 4

export const fitContextMenuToViewport = (menu: HTMLElement) => {
  const currentLeft = parseFloat(menu.style.left) || 0
  const currentTop = parseFloat(menu.style.top) || 0
  // offsetWidth/offsetHeight ignore CSS transforms (the menu starts at
  // transform: scale(0)), so they return the menu's intrinsic layout size.
  const width = menu.offsetWidth
  const height = menu.offsetHeight
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  let nextLeft = currentLeft
  let nextTop = currentTop

  if (currentLeft + width > viewportWidth) {
    nextLeft = viewportWidth - width - VIEWPORT_MARGIN
  }
  if (currentTop + height > viewportHeight) {
    nextTop = viewportHeight - height - VIEWPORT_MARGIN
  }
  if (nextLeft < VIEWPORT_MARGIN) {
    nextLeft = VIEWPORT_MARGIN
  }
  if (nextTop < VIEWPORT_MARGIN) {
    nextTop = VIEWPORT_MARGIN
  }

  if (nextLeft !== currentLeft) {
    menu.style.left = `${nextLeft}px`
  }
  if (nextTop !== currentTop) {
    menu.style.top = `${nextTop}px`
  }
}

let isInstalled = false

export const installContextMenuViewportFitter = () => {
  if (isInstalled) {
    return
  }
  isInstalled = true
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node instanceof HTMLElement &&
          node.classList.contains("context-menu")
        ) {
          fitContextMenuToViewport(node)
        }
      }
    }
  })
  observer.observe(document.body, { childList: true })
}
